
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ReservationDetailDto_$reflection } from "../../Shared/Planning.js";
import { CustomerConfiguration_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { PropertyConfiguration_$reflection } from "../../Shared/PropertyConfiguration.js";
import { union_type, class_type, record_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(Reservation, CustomerConfiguration, PropertyConfigurations) {
        super();
        this.Reservation = Reservation;
        this.CustomerConfiguration = CustomerConfiguration;
        this.PropertyConfigurations = PropertyConfigurations;
    }
}

export function State_$reflection() {
    return record_type("Reservation.Detail.Types.State", [], State, () => [["Reservation", RequestedValue$1_$reflection(ReservationDetailDto_$reflection())], ["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["PropertyConfigurations", RequestedValue$1_$reflection(list_type(PropertyConfiguration_$reflection()))]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FetchReservation", "ReservationFetched", "CustomerConfigurationFetched", "PropertyConfigurationsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Reservation.Detail.Types.Msg", [], Msg, () => [[], [["Item", ReservationDetailDto_$reflection()]], [["Item", CustomerConfiguration_$reflection()]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

